import { Component } from '@angular/core';
import { PaymentCodeService } from '../../../services/payment-code.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { getCurrencySymbol } from '../../../admin/currencies';

@Component({
  selector: 'app-price',
  standalone: true,
  templateUrl: './price.component.html',
  imports: [
    AsyncPipe,
    NgIf,
    TranslatePipe,
  ],
  styleUrls: ['./price.component.scss'],
})
export class priceComponent {
  constructor(public paymentCodeService: PaymentCodeService) {}

  getCurrencySymbol(currency?: string): string {
    return getCurrencySymbol(currency || 'USD');
  }
}
